import ApplicationSerializer from './application';

export default class TasAssetSerializer extends ApplicationSerializer {
  belongsToRelationshipToOmit = ['assetSummary'];

  serializeBelongsTo(snapshot: unknown, json: unknown, relationship: { key: string }) {
    if (this.belongsToRelationshipToOmit.includes(relationship.key)) {
      return;
    }

    super.serializeBelongsTo(snapshot, json, relationship);
  }
}
